import { useState, useCallback, useEffect } from "react";

import { api_without_cancellation } from "../../../../../api/api";

const useClientPage = (clientId, caseId) => {
  const [clientData, setClientData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchClientPage = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await api_without_cancellation.get(
        `/api/client-page/client/${clientId}/case/${caseId}/`
      );

      setClientData(response.data);
      return response.data;
    } catch (err) {
      console.error("Failed to fetch client data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [clientId, caseId]);

  // Automatically fetch on mount and when dependencies change
  useEffect(() => {
    fetchClientPage();
  }, [fetchClientPage]);

  const refetch = useCallback(() => {
    return fetchClientPage();
  }, [fetchClientPage]);

  return {
    clientData,
    loading,
    error,
    refetch,
  };
};

export default useClientPage;
